import React from 'react';

const ReadOnlyRating = ({rating}) => {
    // Generate stars based on the rating
    const stars = [];
    for(let i = 1; i <= 5; i++) {
        if(i <= rating) {
            stars.push(<span style={{ color: 'gold', fontSize:'25px' }} key={i}>&#9733;</span>); // Filled star
        } else {
            stars.push(<span style={{ fontSize:'25px' }} key={i}>&#9734;</span>); // Empty star
            // stars.push(<span style={{ color: 'lightgray', fontSize:'25px' }} key={i}>&#9733;</span>); // Filled star

        }
    }

    return (
        <div className="readOnlyRating">
            {stars}
        </div>
    );
};

export default ReadOnlyRating;